/** @format */

import { NestDefiningAttribute } from './nest-defining-attribute.interface';
import { Image } from './image.interface';
import { ParentCatGroup } from './parent-cat-group.interface';
import { NestMultiProductPrices } from './nest-multi-product-prices.interface';
import { StyleDescriptiveAttribute } from './style-descriptive-attribute.interface';
import { NestProductSKU } from './nest-product-sku.interface';

export interface NestProduct {
  atLeastOneSkuBopis: boolean;
  bopisFlag: string;
  bundleComponents: string;
  bundleEcodeSearch: boolean;
  buyable: boolean;
  calcodeList: string;
  catentryId: number;
  defAttributes?: NestDefiningAttribute[];
  descAttributes: StyleDescriptiveAttribute[];
  ecodePresale: boolean;
  gtgtenabled: boolean;
  id: string;
  image: Image;
  invFlag: boolean;
  isAtLeastOneSkuBopis: boolean;
  isEcodePresale: boolean;
  isaFlag: boolean;
  longDescription: string;
  oosFlag: string;
  parentCatGroup: ParentCatGroup[];
  parentPartNumber: string;
  pdpSeoUrl: string;
  price: NestMultiProductPrices;
  priceList: string;
  seePriceInCart: boolean;
  shortDescription: string;
  sizeChart: string;
  skus: NestProductSKU[];
  techSpecs: string;
  title: string;
}
